package app.bloomey.web.modules.feedback

import app.bloomey.web.core.data.UiState
import app.bloomey.web.utils.ApiError
import kotlinx.coroutines.flow.flow

class FeedbackRepository {
    private val api = FeedbackApi()

    suspend fun getFeedbacks(page: Int, size: Int, query: String) = flow {
        try {
            emit(UiState.Loading)
            val response = api.getFeedbacks(page, size, query)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e, "Unable to get feedbacks")))
        }
    }
}